import baseScmService from 'services/baseScmService';

const academyTopicAcademyProjectService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    deleteAcademyTopicAcademyProject: build.mutation({
      query: ({ academyTopicId, academyProjectId }) => ({
        url: `academy-topics/${academyTopicId}/academy-projects/${academyProjectId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, { academyTopicId, academyProjectId }) =>
        error
          ? []
          : [
              { type: 'AcademyTopic', id: academyTopicId },
              { type: 'AcademyProject', id: academyProjectId },
            ],
    }),
    createAcademyTopicAcademyProject: build.mutation({
      query: ({ academyTopicId, academyProjectId }) => {
        return {
          method: 'POST',
          url: `academy-topics/${academyTopicId}/academy-projects`,
          body: {
            id: academyProjectId,
          },
        };
      },
      invalidatesTags: (
        result,
        error,
        { academyTopicId, academyProjectId }
      ) => {
        return error
          ? []
          : [
              { type: 'AcademyTopic', id: academyTopicId },
              { type: 'AcademyProject', id: academyProjectId },
            ];
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useDeleteAcademyTopicAcademyProjectMutation,
  useCreateAcademyTopicAcademyProjectMutation,
} = academyTopicAcademyProjectService;

export default academyTopicAcademyProjectService;
